var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-3 mb-1 fractions-table" },
    [
      !_vm.selectedObject.data
        ? _c(
            "h3",
            {
              staticClass: "d-flex align-center",
              on: {
                click: function($event) {
                  return _vm.$emit("open-and-close-fractions-table")
                }
              }
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$tc("Fraction", 2)) + " \n        "
              ),
              _vm.fractionsTableIsOpen
                ? _c("span", { staticClass: "material-icons" }, [
                    _vm._v("expand_more")
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.fractionsTableIsOpen
                ? _c("span", { staticClass: "material-icons" }, [
                    _vm._v("expand_less")
                  ])
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedObject.data
        ? _c("div", { staticClass: "table-title" }, [
            _c("span", { staticStyle: { "text-transform": "capitalize" } }, [
              _vm._v(
                _vm._s(
                  _vm.$tc(_vm.selectedObject.type, 1) +
                    " " +
                    _vm.selectedObject.index +
                    " | " +
                    _vm.$tc("Fraction", 2)
                )
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      (!!_vm.selectedObject.data
      ? true
      : _vm.fractionsTableIsOpen)
        ? _c("v-data-table", {
            attrs: {
              dense: "",
              "hide-default-footer": "",
              "disable-sort": "",
              headers: _vm.headers
            },
            scopedSlots: _vm._u(
              [
                !_vm.actionTypeIsView
                  ? {
                      key: "header.addButton",
                      fn: function() {
                        return [
                          _c("thead", [
                            _c(
                              "th",
                              { staticStyle: { "padding-left": "30%" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "add-button",
                                    attrs: { "x-small": "", depressed: "" },
                                    on: { click: _vm.openDialog }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "#4fa2b7" } },
                                      [_vm._v("add_box")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ]
                      },
                      proxy: true
                    }
                  : null,
                {
                  key: "body",
                  fn: function() {
                    return [
                      _c(
                        "tbody",
                        _vm._l(_vm.fractions, function(item, itemIndex) {
                          return _c(
                            "tr",
                            {
                              key: itemIndex,
                              staticClass: "cursor-pointer",
                              on: {
                                click: function($event) {
                                  return _vm.selectItem(itemIndex, item)
                                }
                              }
                            },
                            [
                              _c("td", [_vm._v(_vm._s(item.floorbox_label))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.client_id))]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c("span", _vm._g({}, on), [
                                                  _vm._v(_vm._s(item.address))
                                                ])
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [_vm._v(_vm._s(item.address))])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              !_vm.selectedObject.data
                                ? _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getFloorNumber(item.floor_uuid)
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selectedObject.data
                                ? _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getContractStatus(
                                          item.contract_status
                                        )
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.actionTypeIsView
                                ? _c(
                                    "td",
                                    [
                                      _c("app-datatable-action-buttons", {
                                        attrs: {
                                          "user-can-edit": true,
                                          "user-can-delete": true
                                        },
                                        on: {
                                          edit: function($event) {
                                            return _vm.editItem(item, itemIndex)
                                          },
                                          delete: function($event) {
                                            return _vm.askConfirmationToDeleteItem(
                                              item
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              true
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.deleteDialog,
          title: _vm.$t("DeleteItem"),
          content: _vm.$t("DeleteConfirmation") + "?",
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes")
        },
        on: {
          mainAction: _vm.closeDeleteDialog,
          secondaryAction: _vm.deleteItem
        }
      }),
      _vm._v(" "),
      _vm.fractionFormIsOpen
        ? _c("fraction-form", {
            attrs: {
              "dialog-is-open": _vm.fractionFormIsOpen,
              "object-to-edit": _vm.itemToEdit.data,
              "all-fractions": _vm.selectedObject.data ? false : true,
              floors: _vm.floors,
              "selected-object": _vm.selectedObject,
              cableTypeFiveOptions: _vm.cableTypeFiveOptions
            },
            on: {
              "close-dialog": _vm.closeFractionDialog,
              "create-fraction": function($event) {
                return _vm.$emit("create-fraction", $event)
              },
              "edit-fraction": function($event) {
                return _vm.saveObject($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ccde0682", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ccde0682","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/FractionsTable.vue
// module id = null
// module chunks = 